import registrations from "./registrationInboxes";
import collections from "./collectionInboxes";
import assessments from "./assessmentInboxes";
import documentInboxes from "./documentInboxes";

const inboxService = [
    {
        matcher: 'inboxes/registrations',
        reply: config => {
            return [200, registrations];
        }
    },
    {
        matcher: /inboxes\/registrations\/(.*)/,
        reply: config => {
            const uuid = /inboxes\/registrations\/(.*)/.exec(config.url)[1];
            const registration = registrations.find(registration => registration.uuid === uuid);
            return [200, registration];
        }
    },
    {
        matcher: 'inboxes/collections',
        reply: config => {
            return [200, collections];
        }
    },
    {
        matcher: /inboxes\/collections\/(.*)/,
        reply: config => {
            const uuid = /inboxes\/collections\/(.*)/.exec(config.url)[1];
            const collection = collections.find(data => data.uuid === uuid);
            return [200, collection];
        }
    },
    {
        matcher: 'inboxes/documents',
        reply: config => {
            return [200, documentInboxes];
        }
    },
    {
        matcher: /inboxes\/documents\/(.*)/,
        reply: config => {
            const uuid = /inboxes\/documents\/(.*)/.exec(config.url)[1];
            const data = documentInboxes.find(item => item.uuid === uuid);
            return [200, data];
        }
    },
    {
        matcher: 'inboxes/assessments',
        reply: config => {
            const {predicate} = config.params;

            // return [200, assessments];
            let data;
            if(predicate?.node()?.selector?.()==='phase') {
                const phase = predicate.node().expectation();
                const regexp = new RegExp(phase.replaceAll('*', '.*'));
                data = assessments.filter(assessment => regexp.test(assessment.phase));
            } else {
                data = assessments;
            }
            return [200, data];
        }
    },
    {
        matcher: /inboxes\/assessments\/(.*)/,
        reply: config => {
            const uuid = /inboxes\/assessments\/(.*)/.exec(config.url)[1];
            const assessment = assessments.find(data => data.uuid === uuid);
            return [200, assessment];
        }
    },

]

export default inboxService;